import api from 'api';

const unwrapData = response => (response && response.data ? response.data : response);

const getSuggestion = ({ photoId, candidateSpotIds, model, regenerate, queue }) => {
  return api.autoModeration
    .getSuggestion({ photoId, candidateSpotIds, model, regenerate, queue })
    .then(unwrapData)
    .then(data => (data && data.suggestion ? data.suggestion : data));
};

// Unsplash photos that NoFilter users have located from the app, with their
// answers already clustered into standpoints by the backend.
const getDetectiveQueue = () => {
  return api.autoModeration.getDetectiveQueue().then(unwrapData);
};

// Unsplash photos nobody has located. nearSpots asks for the ones close enough
// to an existing spot to be worth a model call, which is a different walk over
// the pile and carries its own cursor.
// safe asks for the safe judge's photos: a phone's own coordinate, or a tag that
// names a place rather than a town.
const getUnsplashQueue = ({ after, nearSpots, safe, pointKind } = {}) => {
  return api.autoModeration.getUnsplashQueue({ after, nearSpots, safe, pointKind }).then(unwrapData);
};

const getGroupRepresentative = ({ photoIds, model }) => {
  return api.autoModeration.getGroupRepresentative({ photoIds, model }).then(unwrapData);
};

const reviewSuggestion = review => {
  return api.autoModeration.reviewSuggestion(review).then(unwrapData);
};

const recoverApplying = () => {
  return api.autoModeration.recoverApplying().then(unwrapData);
};

// The bench: photos the owner decided by hand in /moderation, replayed through
// the Unsplash judge so its precision is measured on his own past decisions.
const getBenchBatch = ({ limit } = {}) => {
  return api.autoModeration.getBenchBatch({ limit }).then(unwrapData);
};

const runBenchPhoto = ({ photoId, candidateSpotIds, model }) => {
  return api.autoModeration.runBenchPhoto({ photoId, candidateSpotIds, model }).then(unwrapData);
};

// Past Super Spots the owner has not yet said anything about, and his answer.
const getSuperSpotQuestions = ({ limit } = {}) => {
  return api.autoModeration.getSuperSpotQuestions({ limit }).then(unwrapData);
};

const saveSuperSpotReason = ({ spotId, reason, source, photoId }) => {
  return api.autoModeration
    .saveSuperSpotReason({ spotId, reason, source, photoId })
    .then(unwrapData);
};

// Today's spend as the backend counted it. The nightly run asks for suggestions
// with no page open, so the page's own counter never saw those tokens land.
const getTokenUsage = () => {
  return api.autoModeration.getTokenUsage().then(unwrapData);
};

const actionsAutoModeration = {
  getBenchBatch,
  getTokenUsage,
  getSuperSpotQuestions,
  runBenchPhoto,
  saveSuperSpotReason,
  getDetectiveQueue,
  getUnsplashQueue,
  getGroupRepresentative,
  getSuggestion,
  recoverApplying,
  reviewSuggestion,
};

export default actionsAutoModeration;
